import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-label-type',
  templateUrl: './formly-label-type.component.html',
  styleUrl: './formly-label-type.component.scss',
})
export class FormlyLabelTypeComponent extends FieldType {}
